import { useAccountsContext } from 'hooks/context/useAccountsContext'

export const useIsDirectEarning = () => {
  const { accountCapabilities } = useAccountsContext()

  const {
    isEmbeddedCustomerCompanyCapabilityEnabled,
    isEmbeddedCustomerIndividualCapabilityEnabled,
  } = accountCapabilities || {}

  const isEmbeddedPartner = Boolean(
    isEmbeddedCustomerCompanyCapabilityEnabled || isEmbeddedCustomerIndividualCapabilityEnabled
  )

  return !isEmbeddedPartner
}
